<template>
  <BaseDialog
    title="Logs"
    v-model="showIntegrationLogDetail"
    width="70%"
    cardTextClass="px-4 pt-4"
  >
    <template #information>
      <v-row col="12">
        <v-col cols="6">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>Name</span>
              </div>
              <p>{{ LogData.name }}</p>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="6">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>Object Type</span>
              </div>
              <p>{{ LogData.object_type }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row col="12">
        <v-col cols="4">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>Event</span>
              </div>
              <p>{{ LogData.event }}</p>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="8">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>url</span>
              </div>
              <p>{{ LogData.url }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row col="12">
        <v-col cols="6">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>Header</span>
              </div>
              <JsonViewer :value="LogData.header || {}" copyable></JsonViewer>
              <!-- <JsonViewer :value="{}" copyable></JsonViewer> -->
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card outlined>
            <v-card-text class="pa-2">
              <div class="d-flex">
                <span>Output Schema</span>
              </div>
              <JsonViewer
                :value="LogData.output_schema || {}"
                copyable
              ></JsonViewer>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </BaseDialog>
</template>
    
    <script>
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import JsonViewer from "vue-json-viewer";

export default {
  components: {
    BaseDialog,
    JsonViewer,
  },
  props: {
    value: {
      required: true,
      type: Boolean,
    },
    integrationPartnerId: {
      required: true,
    },
  },
  data() {
    return {
      LogData: {},
    };
  },
  computed: {
    showIntegrationLogDetail: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.getIntegrationLogsDetail();
      } else {
        // this.reset();
      }
    },
  },
  methods: {
    getIntegrationLogsDetail() {
      // this.$bus.$emit("showLoader", true);
      this.$api.integrationPartner
        .getIntegrationPartnerObject(this.integrationPartnerId)
        .then((res) => {
          // this.$bus.$emit("showLoader", false);
          this.LogData = res.data;
        })
        .catch((err) => {
          // this.$bus.$emit("showLoader", false);
          console.log(err);
        });
    },
  },
};
</script>
    
    <style></style>